import type { FacetRemovedPayload } from '@awaze/mfe-common.contexts.tms'
import { TmsContextType } from '@awaze/mfe-common.contexts.tms'
import {
  DataLayerEventType,
  DataLayerFactory,
} from '@awaze/mfe-common.contexts.tms'

import { dataLayerErrorHandler } from '@/utils/dataLayerErrorHandler'

interface FireFacetRemovedEventProps {
  clickedFeature: FacetRemovedPayload['feature']
  tms: TmsContextType
}

export const fireFacetRemovedEvent = ({
  clickedFeature,
  tms,
}: FireFacetRemovedEventProps): void => {
  new DataLayerFactory().getEvent(DataLayerEventType.FacetRemoved).update(
    tms,
    {
      feature: clickedFeature,
    },
    dataLayerErrorHandler,
  )
}
